import React, { Component } from "react";
import PropTypes from "prop-types";
import { Message } from "semantic-ui-react";
import { AbuseReportModal } from "./AbuseReportModal/AbuseReportModal";

export class AbuseReport extends Component {
  render() {
    const { record, isDraft } = this.props;

    return (
      <>
        <AbuseReportModal pid={record.id} />

        {isDraft && (
          <Message warning className="mt-10">
            This is a draft record.
          </Message>
        )}
      </>
    );
  }
}

AbuseReport.propTypes = {
  record: PropTypes.object.isRequired,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  isDraft: PropTypes.bool.isRequired,
};
